import React from "react";
import AnswerMarkdown from "shared/components/chat/AnswerMarkdown";
import ChatNotice from "shared/components/chat/ChatNotice";

/**
 * A run that ended without an answer: stopped, out of credit, paused or
 * failed. A notice, not an answer: no thumbs, nothing to add to a dashboard.
 * The sentence is the server's; the link is what to do next.
 */
const TONE = { failed: "danger", no_credit: "warning" };

export default function RunEndedNote({ reason, text, billingHref }) {
  return (
    <ChatNotice tone={TONE[reason] || "neutral"} role={reason === "failed" ? "alert" : "note"}>
      <AnswerMarkdown text={text || "This run ended without an answer."} />
      {reason === "no_credit" && billingHref && (
        <a href={billingHref} className="inline-block mt-1.5 text-[13px] font-medium hover:underline" style={{ color: "rgb(var(--trodo-primary-rgb))" }}>
          Add credit
        </a>
      )}
    </ChatNotice>
  );
}
